import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import HomePage from './pages/HomePage';
import AIInsights from './pages/AIInsights';
import AIHire from './pages/AIHire';
import Waitlist from './pages/Waitlist'; // Import the new Waitlist component
import Login from './pages/Login';
import IntakeForm from './pages/IntakeForm';
import Results from './pages/ResultPage';
import Services from './pages/Services';
import About from './pages/AboutUs';
import SignupPage from './pages/SignUp';
import TestConnection from './pages/TestConnection';

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/ai-insights" element={<AIInsights />} />
          <Route path="/ai-hire" element={<AIHire />} />
          <Route path="/waitlist" element={<Waitlist />} /> {/* Add this route */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/intakeform" element={<IntakeForm />} />
          <Route path="/results/:submissionId" element={<Results />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/test" element={<TestConnection />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;